import HomeHeroComponent from "../../../Components/Admin/CMS/Home/HomeHeroComponent";

function HomeHero() {
  return (
    <main className='flex-1 h-screen overflow-x-auto bg-[#f5f5f5]'>
      <HomeHeroComponent />
    </main>
  );
}

export default HomeHero;
